import { wsActions } from "../redux/actions/ws.actions";
import { GetState } from "../redux/reducers";
import { Socket } from "socket.io-client";
import { WsConnectionOpenResult } from "../models/ws.model";

export const setupWebSocketActionHandlers = (
  socket: Socket,
  dispatch: Function,
  getState: GetState
) => {
  socket.on("connect", () => {
    console.log("ws connected");
  });

  socket.on("connection_open", (res: WsConnectionOpenResult) => {
    console.log("connection_open:", res);
    const authState = getState().authReducer;
    socket.emit("login", {
      user_type: authState.userInfo?.user_type,
      id: authState.userInfo?.id,
    });
    dispatch(
      wsActions.connectDone({
        params: {},
        result: {
          sid: res.sid,
          socket,
        },
      })
    );
  });

  socket.on("disconnect", () => {
    console.log("ws disconnected");
    dispatch(wsActions.disconnect());
  });

  socket.on("error", () => {
    console.warn("ws can not open");
    dispatch(
      wsActions.connectFailed({
        params: {},
        error: "websocketの接続に失敗しました",
      })
    );
  });

  socket.on("connect_error", (err) => {
    console.warn("ws connect_error", err);
    dispatch(
      wsActions.connectFailed({
        params: {},
        error: (err as any)?.message || (err as any),
      })
    );
  });

  socket.on("reconnect", () => {
    console.log("ws reconnected");
    // ルーム再参加は各画面で wsState.connected を監視して実施
  });
};

